import React, { useState } from 'react';

const timelineSteps = [
  { id: 1, title: 'Reward', description: 'Select your reward', status: 'done' },
  { id: 2, title: 'Timeline', description: 'Choose duration', status: 'active' },
  { id: 3, title: 'Points', description: 'Review points', status: '' },
  { id: 4, title: 'Activities', description: 'Choose activities', status: '' },
  { id: 5, title: 'Review', description: 'Confirm goals', status: '' },
  { id: 6, title: 'Track', description: 'Monitor progress', status: '' },
];

const calculateEndDate = (duration) => {
  const currentDate = new Date(); 
  let endDate = new Date(currentDate);

  if (duration === '1 Day') {
    endDate.setDate(currentDate.getDate() + 1);
  } else {
    const months = parseInt(duration.split(' ')[0]);
    endDate.setMonth(currentDate.getMonth() + months);
  }

  return endDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

const timelines = [
  { id: 2, duration: '3 Months', endDate: calculateEndDate('3 Months'), image: 'images/time-slot.png' },
  // { id: 3, duration: '6 Months', endDate: calculateEndDate('6 Months'), image: 'images/time-slot.png' },
  // { id: 4, duration: '9 Months', endDate: calculateEndDate('9 Months'), image: 'images/time-slot.png' },
  // { id: 5, duration: '12 Months', endDate: calculateEndDate('12 Months'), image: 'images/time-slot.png' },
];

const TimelineContent = ({ updateFormData, setActiveSection, formData }) => {
  const [selectedTimeline, setSelectedTimeline] = useState(null);

  const handleSelect = (timeline) => {
    const formattedData = {
        Duration: timeline.duration,
        EndDate: timeline.endDate,
 
    };
    setSelectedTimeline(timeline);
    updateFormData(formattedData);
    setActiveSection('points_timeline');
  };

  return (
    <main>
      <div className="timeline">

        <div className="timeline-content">
          <div className="timeline-content-inner active" id="achievement_timeline">
            <div className="timeline-achievement">
              <h4>
                <i class="fa-solid fa-calendar-days"></i>
                Achievement Timeline
              </h4>
             
              <div className="timeline-achievement-grid">
                {timelines.map((timeline) => (
                  <button
                    key={timeline.id}
                    className="timeline-achievement-box"
                    onClick={() => handleSelect(timeline)}
                  >
                    <img src={timeline.image} alt="time slot" />
                    <h5>{timeline.duration}</h5>
                    <p>Ends on {timeline.endDate}</p>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TimelineContent;